import * as Yup from 'yup';

const topicSchema = Yup.object().shape({
  title: Yup.string().required('Topic name is required.').max(12),
});
export default topicSchema;
